import { render, staticRenderFns } from "./TheSidebarRight.vue?vue&type=template&id=0433433c&"
import script from "./TheSidebarRight.vue?vue&type=script&lang=js&"
export * from "./TheSidebarRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports